export const ABSOLUTE = 'Fixed dollar';
export const RELATIVE = 'Percentage';


// WEBPACK FOOTER //
// ./src/constants/bonus-payment-types.js